export enum Button {
    OmOss = "OmOss",
    UpperKontakt = "UpperKontakt",
    LowerKontakt = "LowerKontakt"
}